import { render, staticRenderFns } from "./pesquisar.vue?vue&type=template&id=2b988bfc&"
import script from "./pesquisar.vue?vue&type=script&lang=js&"
export * from "./pesquisar.vue?vue&type=script&lang=js&"
import style0 from "./pesquisar.vue?vue&type=style&index=0&id=2b988bfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports